
// Version identifier for service queries
// Update this when making changes to query structure to invalidate caches
export const QUERY_VERSION = 'v2.1'; // Incremented due to query structure changes

// Cache stale times in milliseconds
export const STALE_TIMES = {
  default: 5 * 60 * 1000, // 5 minutes
  lowData: 15 * 60 * 1000, // 15 minutes
  offline: 60 * 60 * 1000, // 60 minutes
};

// Garbage collection times in milliseconds
export const GC_TIMES = {
  default: 10 * 60 * 1000, // 10 minutes
  lowData: 30 * 60 * 1000, // 30 minutes
  offline: 24 * 60 * 60 * 1000, // 24 hours
};

// Define service query strings for different versions
export const serviceQueryStrings = {
  'v1': '*',
  'v2.0': '*, category_details:categories(*), subcategory_details:subcategories(*, parent:parent_category(*))',
  'v2.1': '*, subcategory_details:subcategories(*, parent:parent_category(*))'
};
